import { merge } from 'lodash';
import { AssetModulePreset } from '@rvi/asset-modules';

export const VisolPreset = merge({}, AssetModulePreset, {
    semantic: {
        primary: {
              50: '#e0edfe',
              100: '#b9dbfe',
              200: '#7cbefd',
              300: '#369efa',
              400: '#0c82eb',
              500: '#005cb9',
              600: '#014fa3',
              700: '#064486',
              800: '#0b3a6f',
              900: '#07244a',
        }
    }
});
